import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Cookie from 'js-cookie';

import { authVerifyToken } from './actions/auth';
import { JWT_TOKEN_KEY, MAINTENANCE_MODE, MAINTENANCE_MESSAGE } from './constants';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import store from './store';
import registerErrorReporter from './registerErrorReporter';
import registerGTM from './registerGTM';
import ScrollTop from './components/ScrollTop';
import Analytics from './components/Analytics';
import Maintenance from './pages/Maintenance';

const token = Cookie.get(JWT_TOKEN_KEY);
if (!MAINTENANCE_MODE && typeof token === 'string' && token !== 'null') {
	store.dispatch(authVerifyToken(token));
}

// Must run before the first render so dataLayer exists for the initial pageview.
registerGTM();

function render(Component) {
	ReactDOM.render(
		<Provider store={store}>
			<Router>
				<Analytics>
					<ScrollTop>
						<Component />
					</ScrollTop>
				</Analytics>
			</Router>
		</Provider>,
		document.getElementById('root')
	);
}

// Maintenance mode renders a static page only, without router, store or API calls.
if (MAINTENANCE_MODE) {
	ReactDOM.render(
		<Maintenance message={MAINTENANCE_MESSAGE} />,
		document.getElementById('root')
	);
} else {
	render(App);
}

if (module.hot && !MAINTENANCE_MODE) {
	module.hot.accept('./App', () => {
		const NextApp = require('./App').default;
		render(NextApp);
	});
}

registerErrorReporter();

// Disable registration of service worker until application is stable
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js